const INDEX_ITEMS = [
  { icon: 'ri-movie-2-line', label: '电影大全', desc: '国内外院线大片与经典影片', color: 'bg-primary-100 text-primary-500' },
  { icon: 'ri-tv-2-line', label: '电视剧集', desc: '热播剧集每日更新不缓冲', color: 'bg-accent-100 text-accent-500' },
  { icon: 'ri-live-line', label: '综艺娱乐', desc: '热门综艺欢乐不间断', color: 'bg-secondary-100 text-secondary-500' },
  { icon: 'ri-ghost-line', label: '动漫番剧', desc: '最新番剧经典动漫全收录', color: 'bg-primary-100 text-primary-500' },
  { icon: 'ri-slideshow-3-line', label: '纪录片', desc: '精品纪录与人文内容', color: 'bg-accent-100 text-accent-500' },
  { icon: 'ri-music-2-line', label: '音乐MV', desc: '热门音乐视频精选合集', color: 'bg-secondary-100 text-secondary-500' },
  { icon: 'ri-gamepad-line', label: '游戏实况', desc: '热门游戏直播与解说', color: 'bg-primary-100 text-primary-500' },
  { icon: 'ri-lightbulb-flash-line', label: '短剧精选', desc: '精品短剧快速追完', color: 'bg-accent-100 text-accent-500' },
  { icon: 'ri-star-line', label: '热门排行', desc: '全网热度实时榜单', color: 'bg-secondary-100 text-secondary-500' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          内容索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          九大内容板块，快速找到你想看的
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.label}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-background-100 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0 ${item.color} transition-transform duration-200 group-hover:scale-110`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 whitespace-nowrap">
                  {item.label}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}